
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.75 2.5L7.5 10h-5L1.25 2.5h.845l1.111 6.667h3.588L7.904 2.5h.846zM6.787.833c-.375 0-.68-.458-.68-.833H3.894c0 .375-.304.833-.68.833H.833v.834h8.334V.833h-2.38z","fill":"#fff"}}),_c('path',{staticClass:"line",attrs:{"d":"M3.75 3.125l.625 5M6.25 3.125l-.625 5","stroke":"#fff","stroke-width":".7","stroke-linecap":"round"}})])
          )
        }
      }
    